var scope_0 = require('C:/Users/Derk-Jan/Documents/Github/mdx-raam/deck/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e3f2057db255c9cc657f4fdc8131d408.js').default;export default
        Object.assign({}, scope_0 )
    